export default class PreparedStatement extends Weaver.QueryBuilder

  arguments: []

  build: (args = {}) ->
    @detectVariables()
    @insertArgs(args)
    super()

  detectVariables: ->
    @arguments = (@payload
      .match(/\%\{[a-z]+\}/g) or [])  # get all the %{var}s
      .map((exp) -> exp.slice(2, -1)) # strip the %{}s


  isDefinedAndNotEmpty = (val) -> val? and val isnt ''

  insertArgs: (args) ->
    receivedArgs = _.keys(_.pickBy(args, isDefinedAndNotEmpty))
    @checkValidity(receivedArgs)
    @transpilePayload(args)

  checkValidity: (receivedArgs) ->
    if missing = @arguments.find((arg) -> receivedArgs.indexOf(arg) is -1)
      throw new Error("Missing required argument: #{ missing }.")

  transpilePayload: (args) ->
    @arguments.map((key) =>
      @payload = @payload.replace(
        ///\%\{#{ key }\}///g, # replace %{var}
        "\"#{ args[key] }\""   # with "var"
      )
    )
